<template>
  <div id="modal">
    <mu-dialog :open="true" scrollable title="新建订单" dialogClass="dialog-order-horizon" titleClass="orderModal-title" bodyClass='order-dialogBody'>
      <mu-stepper style="margin-top:7px;" :activeStep="activeStep">
        <mu-step><mu-step-label>选择用户</mu-step-label></mu-step>
        <mu-step><mu-step-label>选择天数</mu-step-label></mu-step>
        <mu-step><mu-step-label>订单付款</mu-step-label></mu-step>
      </mu-stepper>
      <div class="order-loading" v-if="circular">
        <mu-circular-progress  style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);background-color:rgba(255,255,255,0.8)" :size="60" :strokeWidth="5"/>
      </div>
      <div v-if="create" class="demo-step-content">
        <template>
          <div v-if="activeStep==0" style="height:300px;">
            <mu-text-field style="margin-left:10px;width:80%;" v-model="search" hintText="请输入姓名或手机号搜索" />
            <mu-raised-button label="搜索" style="border-radius:40px;" @click="getCaseList" slot="right" primary />
            <mu-paper class="select-user" :zDepth="1">
              <mu-grid-list>
                <mu-grid-tile v-for="(caseList,index) in caseLists" :key="index" style="height:90px;" >
                  <personal :flag="2" :info="caseList" :keys="index" @disabledStatus="getDisabledStatus" ></personal>
                </mu-grid-tile>
              </mu-grid-list>
            </mu-paper>
          </div>
          <mu-grid-list :cols="1" v-if="activeStep==1" :cellHeight="60">
            <!-- <mu-grid-tile>
              <mu-radio nativeValue = '1'  v-model="chosen_order" style="margin-left:14px;transform:translateY(35%);"></mu-radio>
              <div v-if="activeStep==1" class="amount-wrapper">
                <span class="days">按天数购买</span>
                <changeDay @changeDay="changeDay"></changeDay>
                <span style="position:absolute;top:8px;right:-166px;color:#333;">价格：<span style="color:#2196f3;">30元/天</span></span>
              </div>
            </mu-grid-tile> -->
          </mu-grid-list>
          <div v-if="activeStep==1"  style="position:relative;margin-top:10px;margin-left:14px">
            <!-- <mu-radio nativeValue = '2' @change="package_pay" v-model="chosen_order"></mu-radio>
            <span class="package-days">按套餐购买</span> -->
            <payProduct ref="product" :orgId="orgId" v-if="showProduct" @selectDay="selectDay"></payProduct>
            <div class="product-info">
              <div class="product-content">
                <p v-if="free_rules" v-html = "free_rules"></p>
                <p v-if="expert" v-html = "expert"></p>
              </div>
            </div>
          </div>
          <div class="change-count" v-if="activeStep==1 && pro.min_num != pro.max_num">
            <span class="count-tile">数量</span>
            <changeCount :pro="pro" @setDisabled = "setDisabled"></changeCount>
            <span class="count-tile count-title1">天</span>
          </div>
          <div v-if="activeStep==1" class="date-wrapper beigin-order-time">
              <span class="time">开始时间</span>
              <div class="date-style"></div>
              <mu-date-picker  v-model="orderDate" @change="clearStep" :errorText="errors.first('康复开始时间')" v-validate="'required'"
              icon="date_range" inputClass="date-class" name="康复开始时间" :underlineShow="false" mode="landscape" hintText="请选择康复开始时间"/>
            </div>
          <div v-if="activeStep==2">
            <mu-row gutter>
              <mu-col v-if="sucess" class="show-pay">订单创建成功，请在24小时内完成付款！</mu-col>
              <mu-col v-else class="show-pay">订单创建失败！</mu-col>
            </mu-row>
          </div>
        </template>
      </div>
      <div v-else>
        <div style="text-align:center">新增失败，当前医院已关闭居家康复服务</div>
      </div>
      <!-- slot: actions-->
      <div v-if="create" slot = 'actions'>
        <mu-raised-button @click="getCase" v-if="activeStep==0" label='下一步'  style="border-radius:40px;" :disabled="disabled" primary/>
        <mu-flat-button @click="upToCase" v-if="activeStep==1" label='上一步' :disabled="disabled" style="border-radius:40px;" />
        <mu-raised-button @click="createOrder" :disabled="disableCreate" v-if="activeStep==1" label='下一步'  style="border-radius:40px;" primary />

        <mu-raised-button @click="$emit('close',0)" v-if="activeStep!=2" label='取消'  style="border-radius:40px;margin-left: 30px;" />

        <mu-flat-button @click="$emit('close',1)" v-if="activeStep==2 && sucess" color="black" label="暂不支付" style="border-radius:40px;" />
        <mu-raised-button @click="getOrderToPay" v-if="activeStep==2 && sucess" label='去付款'  style="border-radius:40px;" primary />
        <mu-flat-button @click="$emit('close',1)" v-if="activeStep==2 && !sucess" color="black" label="关闭" style="border-radius:40px;" />
      </div>
      <div v-else>
        <mu-raised-button @click="$emit('close',0)" label='取消'  style="border-radius:40px;margin-left: 30px;margin-top:150px;"/>
      </div>
    </mu-dialog>
    <mu-toast v-if="toast" message="请耐心等待，不要多次点击哦……" @close="hideToast"/>  </div>
</template>
<script>
  import Vue from 'vue'
  import personal from '../../common/personal.vue'
  import payProduct from '../../common/payProduct.vue'
  import {mapState} from 'vuex'
  import changeCount from '../../common/changeCount.vue'
  export default ({
    props: ["caseTrans", "caseId","orgId"],
    data() {
      return {
        select: GLOBAL.selectOption,
        showProduct: false,
        activeStep: 0,
        disabled: true,
        caseLists: [],
        pID: 0,
        orderID: '',
        orderDate: '',
        caseList: {},
        search: '',
        // 点击次数
        clickTime: 0,
        toast: false,
        create:true,//当前机构是否可以下单
        amount:0,//下单的商品规格
        sucess:"",
        circular:false,
        prom:1,//促销的天数
        user_data:"",
        chosen_order:"1",
        ipad:false, //是否有ipad优惠
        free_rules:"", //优惠规则
        expert:"", //专家建议
        add_ipad:false, //是否点击换购ipad
        pro_ipad:"",
        pro_noIpad:"",
        pro:"",
        min:"",
        disableCreate:false,
      }
    },
    components:{
      personal,
      payProduct,
      changeCount,
    },
    computed:{
      ...mapState(["org","count","selected","quantity"])
    },
    mounted (){
      this.$http.get('/api/Users/me').then(
        function (res) {
          this.user_data = res.data;
          console.log(this.user_data);
        },
        function(res){
          console.log(res);
        }
      );
      this.clickTime = 0;
      if(this.caseTrans){
        this.caseList = this.caseTrans;
        this.activeStep = 1;
        this.showProduct = true;
        //档案页新建订单时获取权限
        this.available(this.orgId);
      } else {
        this.getCaseList();
        //从居家康复列表获取权限
        this.available(this.orgId);
      }
    },
    methods: {
      setDisabled(status){
        this.disableCreate = status;
      },
      package_pay(){
        this.$store.commit("getDay","");
      },
      getChange(){
        if(this.add_ipad){
          this.$refs.product.addIpad();
          this.pID = this.pro_ipad.pro_id;
        }else{
          this.$refs.product.reduceIpad();
          this.pID = this.pro_noIpad.pro_id;
        }
      },
      available(orgId){
        //当前机构是否可以使用居家康复订单
        this.$http.get(GLOBAL.ORDER + "goods/" + orgId + "/available",
        {emulateJSON: false})
        .then((res)=>{
          for(var item in res.data){
            if(item == 'need_pay'){
              res.data[item].length > 0 ? "" : this.create = false;
            }
          }
        })
      },
      getCaseList(){
        Vue.http({
          method: 'GET',
          url:'/api/Cases/getList',
          params: {
            'search': {
              'keyword': this.search
            },
            'page': {
              current: 1,
              limit: 10
            }
          }
        })
        .then((res) => {
          this.caseLists = res.data.data;
        })
      },
      getOrderToPay: function() {
        this.$emit("close");
        this.$router.push({name:'orderPay',params:{id:this.orderID}});
      },
      // 如果开始时间没填，修改时要把点击下一步的计数置空
      clearStep(){
        this.clickTime = 0;
      },
      createOrder(){
        console.log(this.pID);
        if(this.count === 0 || this.count.toString().length >= 5 || (this.count == "" && this.selected == -1)){
          //下单时不能填0天的单和大于9999天的单,否则会有提示
          this.$store.commit("changeRightDay",true);
          return
        }
        this.clickTime++;
        console.log(this.clickTime)
        if(this.clickTime > 1){
          this.showToast()
          return;
        }
        var acc = require('../../../app/store.js');
        if(this.caseList.id){
          var id = this.caseList.id;
          var mobile = this.caseList.mobile;
        } else {
          var id = this.caseId;
          var mobile = this.caseList.telephone;
        }
        var body = {
          'user_id': id,
          'user_name': this.caseList.name,
          'user_mobile': mobile,
          'pro_id': this.pID,
          'order_use_start_time': this.orderDate,
          'order_quantity': this.quantity,
          'remark': 'remark',
          'order_mode': 1,
          "doc_mobile": this.user_data.mobile,
          'doc_id': this.user_data.account_uuid,      // 医生id(说明 不可以为空)，类型字符串
          'doc_name': this.user_data.name,  // 医生姓名(说明 不可以为空)，类型字符串
          'dept_id': this.user_data.dept_id,    // 下单人科室(说明 可以为空)，类型字符串
          'dept_name': this.user_data.dept_name,// 下单人科室名称(说明 可以为空)，类型字符串
          'org_id': this.user_data.org_uuid,      // 机构id(说明 可以为空)，类型字符串
          'org_name': this.user_data.orgName,  // 机构名称患者姓名(说明 可以为空)，类型字符串
        };
        var self = this;
        this.$validator.validateAll()
        .then(function(isValid){
          if (false == isValid){
            return;
          }
          self.circular = true;
          self.$http.post(GLOBAL.ORDER+'create',body,
          {emulateJSON: false})
          .then((res)=>{
            self.circular = false;
            self.sucess = true;
            self.orderID = res.data;
            self.activeStep++;
          },(err)=>{
            self.circular = false;
            self.activeStep++;
            self.sucess = false;
            console.log(err);
          })
        })
      },
      upToCase(){
        this.activeStep--;
        this.disabled = true;
      },
      getCase(){
        this.activeStep++;
        this.showProduct = true;
      },
      getDisabledStatus(val,temp){
        this.disabled = val;
        this.caseList = temp;
      },
      /* 选择标签的逻辑 */
      /* day.pro_id,day.days,day.ipad,day.free_rules,day.expert */
      selectDay(day){
        this.pro = day;
        console.log(this.pro);
        this.pID = day.id;
        this.chosen_order = "2";
        this.add_ipad = false;
        this.free_rules = day.des; 
        this.expert = day.expert;
        this.$refs.product.reduceIpad();
        this.$store.commit("getDay","");
		  },
      showToast () {
        this.toast = true
        if (this.toastTimer) clearTimeout(this.toastTimer)
        this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
      },
      hideToast () {
        this.toast = false
        if (this.toastTimer) clearTimeout(this.toastTimer)
      },
      /* 选择康复天数的逻辑 */
      changeDay(id){
        this.amount = parseInt(this.count);
        this.pID = id;
        this.chosen_order = "1";
        this.ipad = false,
        this.$refs.product.reduceIpad();
        this.free_rules = "";
        this.expert = "";
			},
    }
  })
</script>
<style lang="stylus" >
  @import "../../../assets/css/app.styl"
  .dialog-order-horizon
    position relative !important
    width 800px !important
    max-width 800px !important
    height 600px !important
    max-height 600px !important
  .select-user
    height 300px
    overflow-y auto
    overflow-x hidden
  .show-pay
    display flex
    justify-content center
    align-items center
    height 255px
    width 100%
  .mu-grid-tile-titlebar
    height 0 !important;
    background-color #fff !important;

  .date-wrapper{
    position: relative;
    display: inline-block;
    width: 260px;
    height: 40px;
  }
  .date-style{
    position: absolute;
    left: 0px;
    width: 260px;
    height: 40px;
    background-color: #F5F5F5;
    border-radius: 40px;
  }
  .date-wrapper,.amount-wrapper{
    position: relative;
	  left: 80px;
    display: inline-block;
    width: 220px;
    height: 40px;
  }
  .amount-wrapper{
	  width: 200px;
	  left: 95px;
	  font-size: 14px;
  }
  .date-style{
    position: absolute;
    left: 0px;
    width: 260px;
    height: 40px;
    background-color: #F5F5F5;
    border-radius: 40px;
  }
  .date-wrapper .mu-text-field-icon{
	  top:8px;
	  color:#2196f3;
    margin-left:200px;
  }
  .date-wrapper .time{
	  position: absolute;
	  font-size: 14px;
	  left: -70px;
	  top: 10px;
  }
  .amount-wrapper .days{
	  position: absolute;
	  font-size: 14px;
	  left: -93px;
	  top: 10px;
    color:#333333;
  }
 
</style>
<style>
  .dialog-order-horizon .mu-dialog-actions{
    position: absolute !important;
    bottom: 0 !important;
    right:0 !important;
    width: 450px !important;
    border-top: none !important;
    margin-bottom: 22px;
  }
  .order-loading{
    position: absolute;
    top: 0;
    left:0;
    width:800px;
    height: 600px;
    z-index: 100;
    background-color: rgba(255,255,255,0.8);
  }
  /* bug 4371 */
  .order-dialogBody{
    height:530px !important;
    max-height:530px !important;

  }
  .demo-step-content{
    margin-top: 4px;
  }
  .package-days{
    position:absolute;
    top:1;
    left:30px;
    color:#333;
    font-size:14px;
  }
  .product-info{
    position: relative;
    width: 740px;
    height: 90px;
    background-color: #F8F8F8 ;
  }
  .product-info p{
    margin: 0;
  }
  .product-content{
    width:542px;
    height:50px;
    padding-top:10px;
    padding-left:10px;
    font-size:14px;
    color:#333333;
  }
  .product-content p{
    display: inline-block;
  }
  .add-ipad{
    position: relative;
    width: 320px;
    height: 40px;
    padding-top:7px;
  }
  .beigin-order-time{
    position: absolute;
    bottom:28px;
    left: 108px;
    z-index: 99;
  }
  .dialog-order-horizon .mu-text-field.has-icon{
    padding-left:20px !important;
  }
  .orderModal-title{
    justify-content:center!important;
    border-bottom: 1px solid #EEEEEE;
    color: #333333;
    font-size: 16px;
    font-weight: bold; 
  }
  .change-count{
    position: relative;
    padding: 20px 0 0 78px;
  }
  .count-tile{
    position: absolute;
    left: 16px;
    top: 28px;
  }
  .count-title1{
    left: 360px;
  }
</style>



// WEBPACK FOOTER //
// orderModal.vue?45ffa5a7